import { FieldConfig } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import { BaseDealForm } from '../BaseDealForm';

const BASE_FIELDS: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.investmentType',
    label: 'Investment type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.entityName', label: 'Entity name', type: 'text', xs: 12, sm: 6 },
  {
    name: 'dealDetails.industrySector',
    label: 'Industry sector',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.investmentAmount',
    label: 'Investment amount',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ownershipTarget',
    label: 'Ownership target (%)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.preMoneyValuation',
    label: 'Pre-money valuation',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.boardSeat',
    label: 'Board seat',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.targetExitMultiple',
    label: 'Target exit multiple',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const EquityInvestment = () => {
  const [fields, setFields] = useState<FieldConfig[]>(BASE_FIELDS);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const dealTypeKey = 'EQUITY_INVESTMENT';
        const dropdownsData = await DealsService.getDealDropdowns(dealTypeKey);

        const updatedFields = BASE_FIELDS.map((field) => {
          if (field.type === 'select' && field.options) {
            let options: string[] = [];

            switch (field.name) {
              case 'dealDetails.stageName':
                if (dropdownsData.stages && Array.isArray(dropdownsData.stages)) {
                  options = dropdownsData.stages.map((stage: any) => stage.stageName || stage);
                }
                break;
              case 'dealDetails.investmentType':
                if (dropdownsData.investmentType && Array.isArray(dropdownsData.investmentType)) {
                  options = [...dropdownsData.investmentType];
                }
                break;
              case 'dealDetails.industrySector':
                if (dropdownsData.industrySector && Array.isArray(dropdownsData.industrySector)) {
                  options = [...dropdownsData.industrySector];
                }
                break;
              case 'dealDetails.boardSeat':
                if (dropdownsData.boardSeat && Array.isArray(dropdownsData.boardSeat)) {
                  options = [...dropdownsData.boardSeat];
                }
                break;
              case 'dealDetails.clientOrientation':
                if (
                  dropdownsData.clientOrientation &&
                  Array.isArray(dropdownsData.clientOrientation)
                ) {
                  options = [...dropdownsData.clientOrientation];
                }
                break;
              case 'dealDetails.revenueTier':
                if (dropdownsData.revenueTier && Array.isArray(dropdownsData.revenueTier)) {
                  options = [...dropdownsData.revenueTier];
                }
                break;
              case 'dealDetails.clientFitScore':
                if (dropdownsData.clientFitScore && Array.isArray(dropdownsData.clientFitScore)) {
                  options = [...dropdownsData.clientFitScore];
                }
                break;
              case 'dealDetails.careerStage':
                if (dropdownsData.careerStage && Array.isArray(dropdownsData.careerStage)) {
                  options = [...dropdownsData.careerStage];
                }
                break;
              default:
                options = field.options ? [...field.options] : [];
            }

            return {
              ...field,
              options: options.length > 0 ? options : field.options ? [...field.options] : [],
            };
          }
          return field;
        });

        setFields(updatedFields);
      } catch (error) {
        console.error('Failed to fetch dropdown values:', error);
        setFields(BASE_FIELDS);
      }
    };

    fetchDropdowns();
  }, []);

  return <BaseDealForm fields={fields} />;
};
